export const Home = 'home';
export const InformacionAlojamiento = 'InformacionAlojamiento';
export const GruposReservaResumen = 'GruposReservaResumen';
export const GruposPropuestaResumen = 'GruposPropuestaResumen';
export const GruposReservaAlojamientos = 'GruposReservaAlojamientos';
export const GruposReservaFormulario = 'GruposReservaFormulario';
export const GruposReservaFormularioUnirse = 'GruposReservaFormularioUnirse';
export const GruposReservaFormularioUnirseSinAlojamiento = 'GruposReservaFormularioUnirseSinAlojamiento';
export const GruposInformacionViaje = 'GruposInformacionViaje';
export const ViajeResumenPDFResumenPDF = 'ViajeResumenPDF';
export const Buscador = 'Buscador';
export const BuscadorAlojamiento = 'BuscadorAlojamiento';
export const NotFound = 'NotFound';
export const AreaComercial = 'AreaComercial';
export const BuscadorServicios = 'BuscadorServicios';
export const AgrupacionDetalle = 'AgrupacionDetalle';
export const UsuarioDarBajaPublicidad = 'UsuarioDarBajaPublicidad';
export const BuscadorResumen = 'BuscadorResumen';
export const PrespuestoForm = 'PrespuestoForm';
export const BajaEmailPublicitario = 'BajaEmailPublicitario';
export const ValidacionQrServicios = 'ValidarQrServicios';
export const CheckIn = 'CheckIn';
export const Landing = 'landing';
export const ViajesGrupoCatalogo = 'GruposCatalogo';
export const ViajesGrupoModificarReservas = 'ModificarReservas';
export const GruposViajesThankYou = 'ThankYouPage';
export const GruposPropuestaThankYou = 'ThankYouPagePropuesta';
export const GruposPropuestaRechazoThankYou = 'ThankYouPagePropuestaRechazo';
export const GruposViajesErrorPago = 'ErrorPayPage';
export const GruposViajesThankYouRedireccion = 'ThankYouPageRedireccion';
export const UsuarioProximasReservas = 'UsuarioProximasReservas';
export const UsuarioProximasReservasDetalle = 'UsuarioProximasReservasDetalle';
export const UsuarioProximaReservasModificar = 'UsuarioProximaReservasModificar';
export const UsuarioProximaReservasConfirmacion = 'UsuarioProximaReservasConfirmacion';
export const UsuarioRooming = 'UsuarioRooming';
export const FAQS = 'FAQS';
export const TrabajaConNosotros = 'TrabajaConNosotros';
export const BlogLanding = 'BlogLanding';
export const UnirseAComunidad = 'UnirseAComunidad';
export const RegistroFicticioToReal = 'RegistroFicticioToReal';
export const PoliticaPrivacidad = 'PoliticaPrivacidad';
export const PaginasLanding = 'PaginasLanding';
